import React from 'react';
import { Row } from 'react-bootstrap';
import { buildWhereForDates, FormCol, FormFilterCard, FieldDateRanger } from 'motion-components';
import { useTranslation } from 'react-i18next';
import { FormFieldCollectionPointDlg } from 'shared-pages';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  console.log('$$$ buildWhereFromFilterValues VALUES', values);

  if (values) {
    if (values.collectionPointId) {
      where = { ...where, collectionPointId: values.collectionPointId };
    } else {
      where = { ...where, collectionPointId: -1 };
    }

    if (values.isActive !== undefined) {
      where = { ...where, isActive: values.isActive };
    }
    if (values.startDate || values.endDate) {
      console.log('startDate', values.startDate, 'endDate', values.endDate);
      where = {
        ...where,
        ...buildWhereForDates(values.startDate, values.endDate, 'dateCollected'),
      };
    }
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues, disable = false, isGridInForm }) => {
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    if (disable) return;
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }

  const filters = {
    collectionPointId: initialValues?.collectionPointId ?? undefined,
    collectionPointName: initialValues?.collectionPointName ?? '',
    isActive: initialValues?.isActive ?? true,
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
      enableReinitialize={true}
    >
      <Row>
        <FormFieldCollectionPointDlg
          as={FormCol}
          idFieldName="collectionPointId"
          nameFieldName="collectionPointName"
          label={t('Σημείο Συλλογής')}
          required
        />
        <FieldDateRanger as={FormCol} label="Συλλογή από" name="startDate" name2="endDate" />
      </Row>
    </FormFilterCard>
  );
};

